(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["huve-flow-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('huve-flow-offer')) {
    class HuveFlowOffer extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
        this.preview = !this.config.confirmed && (window.Shopify?.theme?.role === 'unpublished' || window.Shopify?.designMode === true);
        if (!this.config.confirmed && !this.preview) return;
        this.productForm = document.getElementById(this.getAttribute('form-id'));
        if (!this.productForm) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.selection = 'none';
        this.pending = false;
        this.buttonLabels = new WeakMap();
        this.formatter = new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency,currencyDisplay:'code'});
        this.querySelectorAll('[data-offer-variant]').forEach(select => {
          select.replaceChildren();
          this.rewards(select.dataset.offerVariant).forEach(variant => {
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.textContent = variant.title + (variant.available ? '' : ' — ' + this.config.strings.soldOut);
            option.disabled = !variant.available;
            select.appendChild(option);
          });
          const preferred = this.rewards(select.dataset.offerVariant).find(v => v.available && String(v.id) === String(this.base()?.id)) || this.rewards(select.dataset.offerVariant).find(v => v.available);
          if (preferred) select.value = String(preferred.id);
          select.hidden = select.options.length < 2;
          this.querySelector(`label[for="${select.id}"]`).hidden = select.hidden;
        });
        this.addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) this.selection = event.target.value;
          this.setError('');
          this.refresh();
        }, options);
        document.addEventListener('change', event => {
          if (event.target.form !== this.productForm) return;
          if (event.target.hasAttribute('data-option-position')) {
            this.pending = true;
            this.selection = 'none';
            this.refresh();
          } else if (event.target.name === 'quantity' || event.target.name === 'selling_plan') this.refresh();
        }, {...options,capture:true});
        this.productForm.addEventListener('variant:change', () => {
          this.pending = false;
          this.selection = 'none';
          this.setError('');
          this.refresh();
        }, options);
        document.addEventListener('input', event => {
          if (event.target.form === this.productForm && event.target.name === 'quantity') this.refresh();
        }, options);
        this.productForm.addEventListener('submit', event => {
          this.submittedOffer = false;
          if (this.pending || (this.selection !== 'none' && !this.selectedReward())) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.setError(this.config.strings[this.pending ? 'updating' : 'changed']);
            return;
          }
          this.submittedOffer = Boolean(this.selectedReward());
        }, {...options,capture:true});
        this.productForm.addEventListener('formdata', event => this.addReward(event.formData), options);
        this.productForm.addEventListener('variant:add', event => {
          if (this.submittedOffer) {
            event.stopPropagation();
            this.submittedOffer = false;
            window.location.assign(this.config.cartUrl);
          }
        }, options);
        window.addEventListener('pageshow', () => { this.pending = false; this.refresh(); }, options);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.productForm?.removeAttribute('data-huve-flow-offer-selected');
        this.closest('safe-sticky')?.removeAttribute('data-huve-flow-offer-selected');
        this.restoreButtons();
      }
      ids(value) { return String(value || '').split(/[\s,]+/).filter(Boolean); }
      base() { return this.config.products.base.find(v => String(v.id) === String(this.productForm.elements.namedItem('id')?.value)); }
      rewards(key) {
        const ids = this.ids(this.config.rewardIds);
        return (this.config.products[key] || []).filter(v => this.preview || ids.includes(String(v.id)));
      }
      eligible(key) {
        const base = this.base();
        return Boolean(base?.available && !this.pending && !this.productForm.elements.namedItem('selling_plan')?.value && (this.preview || this.ids(this.config.qualifying[key]).includes(String(base.id))));
      }
      reward(key) {
        const value = this.querySelector(`[data-offer-variant="${key}"]`)?.value;
        return this.rewards(key).find(v => String(v.id) === value && v.available);
      }
      selectedReward() { return this.selection !== 'none' && this.eligible(this.selection) ? this.reward(this.selection) : null; }
      quantity() {
        const value = Number(this.productForm.elements.namedItem('quantity')?.value || 1);
        return Number.isInteger(value) && value > 0 ? value : 1;
      }
      saving(key, reward) {
        if (!reward || !this.base()) return 0;
        return Math.floor(reward.price * 20 / 100);
      }
      buttons() { return Array.from(this.productForm?.elements || []).filter(element => element.type === 'submit'); }
      restoreButtons() {
        this.buttons().forEach(button => {
          const label = this.buttonLabels?.get(button);
          const content = button.contentElement || button;
          if (label !== undefined && content.textContent.trim() === this.config.strings.addBoth) content.textContent = label;
          this.buttonLabels?.delete(button);
          if (button.hasAttribute('data-huve-flow-offer-pending')) {
            button.disabled = !this.base()?.available;
            button.removeAttribute('data-huve-flow-offer-pending');
          }
        });
      }
      refresh() {
        const base = this.base();
        const reward = this.selectedReward();
        if (!reward) this.selection = 'none';
        this.hidden = !this.preview && !['filter'].some(key => this.ids(this.config.qualifying[key]).includes(String(base?.id)));
        this.setAttribute('aria-busy', String(this.pending));
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = input.value === this.selection;
          input.disabled = this.pending || (input.value !== 'none' && (!this.eligible(input.value) || !this.reward(input.value)));
        });
        this.querySelectorAll('[data-offer]').forEach(card => {
          const key = card.dataset.offer;
          const item = this.reward(key);
          const available = this.eligible(key) && Boolean(item);
          card.querySelector('[data-saving]').textContent = available ? this.config.strings.save.replace('__amount__',this.formatter.format(this.saving(key,item)/100)) : '';
          card.querySelector('[data-unavailable]').hidden = available;
          card.querySelector('.huve-flow-offers__configuration').hidden = this.selection !== key;
          card.querySelector('select').disabled = !available;
          card.querySelector('[data-reward-regular]').textContent = item ? this.formatter.format(item.price/100) : '';
          card.querySelector('[data-reward-price]').textContent = item ? this.formatter.format((item.price-this.saving(key,item))/100) : '';
          const image = card.querySelector('img');
          if (image && item?.image) { image.removeAttribute('srcset'); image.src = item.image; }
        });
        const quantity = this.quantity();
        const saving = reward ? this.saving(this.selection,reward) * Math.min(quantity,5) : 0;
        const total = ((base?.price || 0) + (reward?.price || 0)) * quantity - saving;
        this.querySelector('[data-total-label]').textContent = this.config.strings[reward ? 'estimatedTotal' : 'total'];
        this.querySelector('[data-total]').textContent = this.formatter.format(total/100);
        this.querySelector('[data-summary]').textContent = this.config.strings[reward ? this.selection+'Summary' : 'noneSummary'].replaceAll('__count__',String(quantity));
        this.productForm.dataset.huveFlowOfferSelected = String(Boolean(reward));
        if (this.closest('safe-sticky')) this.closest('safe-sticky').dataset.huveFlowOfferSelected = String(Boolean(reward));
        this.restoreButtons();
        this.buttons().forEach(button => {
          const content = button.contentElement || button;
          if (reward && !button.disabled) {
            this.buttonLabels.set(button,content.textContent.trim());
            content.textContent = this.config.strings.addBoth;
          }
          if (this.pending && !button.disabled) { button.disabled = true; button.setAttribute('data-huve-flow-offer-pending',''); }
        });
      }
      setError(message) { const element=this.querySelector('[data-error]'); element.textContent=message; element.hidden=!message; }
      addReward(formData) {
        const reward = this.selectedReward();
        if (!reward || formData.has('items[0][id]') || String(formData.get('id')) !== String(this.base()?.id)) return;
        const quantity = Number(formData.get('quantity') || 1);
        if (!Number.isInteger(quantity) || quantity < 1) return;
        const same = String(reward.id) === String(this.base().id);
        const fields = Array.from(formData.entries()).filter(([name]) => name === 'id' || name === 'quantity' || name === 'selling_plan' || /^properties\[.*\]$/.test(name));
        fields.forEach(([name,value]) => {
          const itemName = name.startsWith('properties[') ? `items[0][properties]${name.slice(10)}` : `items[0][${name}]`;
          formData.append(itemName,value);
          formData.delete(name);
        });
        formData.set('items[0][quantity]',String(same ? quantity*2 : quantity));
        if (!same) {
          formData.set('items[1][id]',String(reward.id));
          formData.set('items[1][quantity]',String(quantity));
        }
      }
    }
    customElements.define('huve-flow-offer',HuveFlowOffer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["huve-perform-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('huve-perform-offers')) {
    class HuvePerformOffers extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
        // Unverified configuration is a design preview only; never display it on a published theme.
        this.preview = !this.config.confirmed && (window.Shopify?.theme?.role === 'unpublished' || window.Shopify?.designMode === true);
        if (!this.config.confirmed && !this.preview) return;
        this.productForm = document.getElementById(this.getAttribute('form-id'));
        if (!this.productForm) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.selection = 'none';
        this.pending = false;
        this.buttonLabels = new WeakMap();
        this.formatter = new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency,currencyDisplay:'code'});
        this.querySelectorAll('[data-offer-variant]').forEach(select => {
          select.replaceChildren();
          this.rewards(select.dataset.offerVariant).forEach(variant => {
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.textContent = variant.title + (variant.available ? '' : ' — ' + this.config.strings.soldOut);
            option.disabled = !variant.available;
            select.appendChild(option);
          });
          const preferred = this.rewards(select.dataset.offerVariant).find(v => v.available && String(v.id) === String(this.base()?.id)) || this.rewards(select.dataset.offerVariant).find(v => v.available);
          if (preferred) select.value = String(preferred.id);
        });
        this.addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) this.selection = event.target.value;
          this.setError('');
          this.refresh();
        }, options);
        document.addEventListener('change', event => {
          if (event.target.form !== this.productForm) return;
          if (event.target.hasAttribute('data-option-position')) {
            this.pending = true;
            this.selection = 'none';
            this.refresh();
          } else if (event.target.name === 'quantity' || event.target.name === 'selling_plan') this.refresh();
        }, {...options,capture:true});
        this.productForm.addEventListener('variant:change', () => {
          this.pending = false;
          this.selection = 'none';
          this.setError('');
          this.refresh();
        }, options);
        document.addEventListener('input', event => {
          if (event.target.form === this.productForm && event.target.name === 'quantity') this.refresh();
        }, options);
        this.productForm.addEventListener('submit', event => {
          this.submittedOffer = false;
          if (this.pending || (this.selection !== 'none' && !this.selectedReward())) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.setError(this.config.strings[this.pending ? 'updating' : 'changed']);
            return;
          }
          this.submittedOffer = Boolean(this.selectedReward());
        }, {...options,capture:true});
        this.productForm.addEventListener('formdata', event => this.addReward(event.formData), options);
        this.productForm.addEventListener('variant:add', event => {
          if (this.submittedOffer) {
            event.stopPropagation();
            this.submittedOffer = false;
            window.location.assign(this.config.cartUrl);
          }
        }, options);
        window.addEventListener('pageshow', () => { this.pending = false; this.refresh(); }, options);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.productForm?.removeAttribute('data-huve-offer-selected');
        this.closest('safe-sticky')?.removeAttribute('data-huve-offer-selected');
        this.restoreButtons();
      }
      ids(value) { return String(value || '').split(/[\s,]+/).filter(Boolean); }
      base() { return this.config.products.perform.find(v => String(v.id) === String(this.productForm.elements.namedItem('id')?.value)); }
      rewards(key) {
        const ids = this.ids(this.config.rewardIds);
        return (this.config.products[key] || []).filter(v => key !== 'perform' || this.preview || ids.includes(String(v.id)));
      }
      eligible(key) {
        const base = this.base();
        return Boolean(base?.available && !this.pending && !this.productForm.elements.namedItem('selling_plan')?.value && (this.preview || this.ids(this.config.qualifying[key]).includes(String(base.id))));
      }
      reward(key) {
        const value = this.querySelector(`[data-offer-variant="${key}"]`)?.value;
        return this.rewards(key).find(v => String(v.id) === value && v.available);
      }
      selectedReward() { return this.selection !== 'none' && this.eligible(this.selection) ? this.reward(this.selection) : null; }
      quantity() {
        const value = Number(this.productForm.elements.namedItem('quantity')?.value || 1);
        return Number.isInteger(value) && value > 0 ? value : 1;
      }
      saving(key, reward) {
        if (!reward || !this.base()) return 0;
        return Math.round((key === 'perform' ? Math.min(this.base().price,reward.price) * .3 : reward.price * .5));
      }
      buttons() { return Array.from(this.productForm?.elements || []).filter(element => element.type === 'submit'); }
      restoreButtons() {
        this.buttons().forEach(button => {
          const label = this.buttonLabels?.get(button);
          const content = button.contentElement || button;
          if (label !== undefined && content.textContent.trim() === this.config.strings.addBoth) content.textContent = label;
          this.buttonLabels?.delete(button);
          if (button.hasAttribute('data-huve-offer-pending')) {
            button.disabled = !this.base()?.available;
            button.removeAttribute('data-huve-offer-pending');
          }
        });
      }
      refresh() {
        const base = this.base();
        const reward = this.selectedReward();
        if (!reward) this.selection = 'none';
        this.hidden = !this.preview && !['perform','flow'].some(key => this.ids(this.config.qualifying[key]).includes(String(base?.id)));
        this.setAttribute('aria-busy', String(this.pending));
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          input.checked = input.value === this.selection;
          input.disabled = this.pending || (input.value !== 'none' && (!this.eligible(input.value) || !this.reward(input.value)));
        });
        this.querySelectorAll('[data-offer]').forEach(card => {
          const key = card.dataset.offer;
          const item = this.reward(key);
          const available = this.eligible(key) && Boolean(item);
          card.querySelector('[data-saving]').textContent = available ? this.config.strings.save.replace('__amount__',this.formatter.format(this.saving(key,item)/100)) : '';
          card.querySelector('[data-unavailable]').hidden = available;
          card.querySelector('.huve-offers__configuration').hidden = this.selection !== key;
          card.querySelector('select').disabled = !available;
          const image = card.querySelector('img');
          if (image && item?.image) { image.removeAttribute('srcset'); image.src = item.image; }
        });
        const quantity = this.quantity();
        const saving = reward ? this.saving(this.selection,reward) * Math.min(quantity,5) : 0;
        const total = ((base?.price || 0) + (reward?.price || 0)) * quantity - saving;
        this.querySelector('[data-total-label]').textContent = this.config.strings[reward ? 'estimatedTotal' : 'total'];
        this.querySelector('[data-total]').textContent = this.formatter.format(total/100);
        this.querySelector('[data-summary]').textContent = this.config.strings[reward ? this.selection+'Summary' : 'noneSummary'].replaceAll('__count__',String(quantity));
        this.productForm.dataset.huveOfferSelected = String(Boolean(reward));
        if (this.closest('safe-sticky')) this.closest('safe-sticky').dataset.huveOfferSelected = String(Boolean(reward));
        this.restoreButtons();
        this.buttons().forEach(button => {
          const content = button.contentElement || button;
          if (reward && !button.disabled) {
            this.buttonLabels.set(button,content.textContent.trim());
            content.textContent = this.config.strings.addBoth;
          }
          if (this.pending && !button.disabled) { button.disabled = true; button.setAttribute('data-huve-offer-pending',''); }
        });
      }
      setError(message) { const element=this.querySelector('[data-error]'); element.textContent=message; element.hidden=!message; }
      addReward(formData) {
        const reward = this.selectedReward();
        if (!reward || formData.has('items[0][id]') || String(formData.get('id')) !== String(this.base()?.id)) return;
        const quantity = Number(formData.get('quantity') || 1);
        if (!Number.isInteger(quantity) || quantity < 1) return;
        const same = String(reward.id) === String(this.base().id);
        const fields = Array.from(formData.entries()).filter(([name]) => name === 'id' || name === 'quantity' || name === 'selling_plan' || /^properties\[.*\]$/.test(name));
        fields.forEach(([name,value]) => {
          const itemName = name.startsWith('properties[') ? `items[0][properties]${name.slice(10)}` : `items[0][${name}]`;
          formData.append(itemName,value);
          formData.delete(name);
        });
        formData.set('items[0][quantity]',String(same ? quantity*2 : quantity));
        if (!same) {
          formData.set('items[1][id]',String(reward.id));
          formData.set('items[1][quantity]',String(quantity));
        }
      }
    }
    customElements.define('huve-perform-offers',HuvePerformOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["huve-replacement-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('huve-replacement-offers')) {
    class HuveReplacementOffers extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-offer-config]').textContent);
        this.productForm = document.getElementById(this.getAttribute('form-id'));
        this.quantityInput = this.productForm?.elements.namedItem('quantity');
        if (!this.productForm || !this.quantityInput) return;
        this.scope = this.closest('.shopify-section') || this.parentElement;
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.formatter = new Intl.NumberFormat(this.config.locale,{style:'currency',currency:this.config.currency,currencyDisplay:'code'});
        this.buttonLabels = new Map();
        this.settingQuantity = false;
        this.wasSubscribed = this.subscribed();
        this.wasOffer = false;
        this.addEventListener('change', event => {
          if (!event.target.matches('input[type="radio"]') || this.subscribed()) return;
          this.setQuantity(Number(event.target.value));
          this.refresh();
        },options);
        document.addEventListener('change', event => {
          if (this.settingQuantity) return;
          if (event.target.form === this.productForm || (this.scope.contains(event.target) && event.target.matches('[data-radio-type],select'))) this.scheduleRefresh();
        },{...options,capture:true});
        document.addEventListener('input', event => {
          if (event.target === this.quantityInput && !this.settingQuantity) this.refresh();
        },options);
        this.productForm.addEventListener('variant:change',()=>this.refresh(),options);
        this.productForm.addEventListener('submit',()=>{
          this.refresh();
          this.submittedOffer = this.offerSelected();
        },{...options,capture:true});
        this.productForm.addEventListener('variant:add', event => {
          if (!this.submittedOffer) return;
          event.stopPropagation();
          this.submittedOffer = false;
          window.location.assign(this.config.cartUrl);
        },options);
        this.observer = new MutationObserver(records => {
          if (records.some(record => record.target.name === 'selling_plan' || (record.type === 'childList' && Array.from(record.addedNodes).some(node=>node.nodeType===1 && (node.matches('[name="selling_plan"],[data-radio-type]') || node.querySelector('[name="selling_plan"],[data-radio-type]')))))) this.scheduleRefresh();
        });
        this.observer.observe(this.scope,{subtree:true,childList:true,attributes:true,attributeFilter:['value','checked']});
        window.addEventListener('pageshow',()=>this.refresh(),options);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
        this.productForm?.removeAttribute('data-huve-replacement-offer');
        this.closest('safe-sticky')?.removeAttribute('data-huve-replacement-offer');
        this.restoreButtons();
      }
      scheduleRefresh() {
        if (this.refreshFrame) return;
        this.refreshFrame = requestAnimationFrame(()=>{this.refreshFrame=0;if(this.isConnected)this.refresh();});
      }
      subscribed() {
        return Boolean(this.productForm?.elements.namedItem('selling_plan')?.value || this.scope?.querySelector('[data-radio-type="selling_plan_group"]:checked'));
      }
      variant() { return this.config.variants.find(variant=>String(variant.id)===String(this.productForm.elements.namedItem('id')?.value)); }
      quantity() {
        const value = Number(this.quantityInput.value);
        return Number.isInteger(value) && value > 0 ? value : 0;
      }
      setQuantity(value) {
        this.settingQuantity = true;
        this.quantityInput.value = String(value);
        this.quantityInput.dispatchEvent(new Event('input',{bubbles:true}));
        this.quantityInput.dispatchEvent(new Event('change',{bubbles:true}));
        this.settingQuantity = false;
      }
      saving(quantity,price) { return quantity===2 ? Math.floor(price*20/100) : quantity===3 ? price : 0; }
      offerSelected() { return !this.hidden && !this.subscribed() && [2,3].includes(this.quantity()); }
      restoreButtons() {
        this.buttonLabels?.forEach((entry,button)=>{
          const content = button.contentElement || button;
          if (content.textContent.trim()===entry.offer) content.textContent=entry.original;
        });
        this.buttonLabels?.clear();
      }
      write(element,value) { if(element.textContent!==value)element.textContent=value; }
      refresh() {
        const subscribed = this.subscribed();
        if (subscribed && !this.wasSubscribed && this.wasOffer) this.setQuantity(1);
        this.wasSubscribed = subscribed;
        const variant = this.variant();
        const quantity = this.quantity();
        this.hidden = subscribed || !variant?.available;
        this.querySelectorAll('[data-count]').forEach(card=>{
          const count = Number(card.dataset.count);
          const price = variant?.price || 0;
          const saving = this.saving(count,price);
          const input = card.querySelector('input');
          input.checked = !subscribed && count===quantity;
          input.disabled = this.hidden || (this.quantityInput.max!=='' && count>Number(this.quantityInput.max)) || count<Number(this.quantityInput.min || 1);
          this.write(card.querySelector('[data-price]'),this.formatter.format((price*count-saving)/100));
          this.write(card.querySelector('[data-original]'),this.formatter.format(price*count/100));
          card.querySelector('[data-original]').hidden = saving===0;
          this.write(card.querySelector('[data-saving]'),this.config.strings.save.replace('__amount__',this.formatter.format(saving/100)));
          card.querySelector('[data-saving]').hidden = saving===0;
        });
        const offer = this.offerSelected();
        const saving = offer ? this.saving(quantity,variant.price) : 0;
        this.write(this.querySelector('[data-total-label]'),this.config.strings[quantity>3?'beforeDiscounts':'total']);
        this.write(this.querySelector('[data-total]'),this.formatter.format(((variant?.price || 0)*quantity-saving)/100));
        this.write(this.querySelector('[data-summary]'),this.config.strings[offer?'offerSummary':quantity===1?'singleSummary':'customSummary'].replace('__count__',String(quantity)));
        this.productForm.dataset.huveReplacementOffer = String(offer);
        if(this.closest('safe-sticky'))this.closest('safe-sticky').dataset.huveReplacementOffer=String(offer);
        this.restoreButtons();
        if(offer) Array.from(this.productForm.elements).filter(element=>element.type==='submit'&&!element.disabled).forEach(button=>{
          const content = button.contentElement || button;
          const label = this.config.strings.addFilters.replace('__count__',String(quantity));
          this.buttonLabels.set(button,{original:content.textContent.trim(),offer:label});
          this.write(content,label);
        });
        this.wasOffer = offer;
      }
    }
    customElements.define('huve-replacement-offers',HuveReplacementOffers);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["huve-stand-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('huve-stand-selector')) {
    class HuveStandSelector extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-stand-config]').textContent);
        this.productForm = document.getElementById(this.getAttribute('form-id'));
        if (!this.productForm) return;
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.selection = 'none';
        this.pending = false;
        this.buttonLabels = new WeakMap();
        this.formatter = new Intl.NumberFormat(this.config.locale, {style: 'currency', currency: this.config.currency, currencyDisplay: 'code'});
        this.addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) {
            this.selection = event.target.value;
            this.setError('');
            this.refresh();
          }
        }, options);
        document.addEventListener('change', event => {
          if (event.target.form !== this.productForm) return;
          if (event.target.hasAttribute('data-option-position')) {
            this.pending = true;
            this.selection = 'none';
            this.setError('');
            this.refresh();
          } else if (event.target.name === 'quantity') {
            this.refresh();
          }
        }, {...options, capture: true});
        this.productForm.addEventListener('variant:change', () => {
          this.pending = false;
          this.selection = 'none';
          this.setError('');
          this.refresh();
        }, options);
        this.productForm.addEventListener('submit', event => {
          if (this.pending) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.setError(this.config.strings.updating);
          } else if (this.selection !== 'none' && !this.selectedStand()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.selection = 'none';
            this.refresh();
            this.setError(this.config.strings.changed);
          }
        }, {...options, capture: true});
        this.productForm.addEventListener('formdata', event => this.addStand(event.formData), options);
        this.productForm.addEventListener('variant:add', event => {
          const standIds = Object.values(this.config.stands).flat().map(stand => String(stand.id));
          if (event.detail.items?.some(item => standIds.includes(String(item.id)))) {
            event.stopPropagation();
            window.location.assign(this.config.cartUrl);
          }
        }, options);
        document.addEventListener('input', event => {
          if (event.target.form === this.productForm && event.target.name === 'quantity') this.refresh();
        }, options);
        window.addEventListener('pageshow', () => { this.pending = false; this.refresh(); }, options);
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.productForm?.removeAttribute('data-huve-stand-selected');
        this.closest('safe-sticky')?.removeAttribute('data-huve-stand-selected');
        this.restoreButtons();
      }
      panel() {
        const id = this.productForm.elements.namedItem('id')?.value;
        return this.config.panels.find(variant => String(variant.id) === String(id));
      }
      isEligible(panel = this.panel()) {
        return panel?.options[this.config.modelIndex] === this.config.eligibleModel;
      }
      stand(key, panel = this.panel()) {
        const colour = panel?.options[this.config.colourIndex]?.toLowerCase();
        return this.config.stands[key]?.find(variant => variant.colour.toLowerCase() === colour);
      }
      selectedStand() {
        const panel = this.panel();
        const stand = this.stand(this.selection, panel);
        return !this.pending && this.isEligible(panel) && panel.available && stand?.available ? stand : null;
      }
      quantity() {
        const value = Number(this.productForm.elements.namedItem('quantity')?.value || 1);
        return Number.isInteger(value) && value > 0 ? value : 1;
      }
      buttons() {
        return Array.from(this.productForm?.elements || []).filter(element => element.type === 'submit');
      }
      restoreButtons() {
        this.buttons().forEach(button => {
          const label = this.buttonLabels?.get(button);
          if (label !== undefined) (button.contentElement || button).textContent = label;
          if (button.hasAttribute('data-huve-pending')) {
            button.disabled = false;
            button.removeAttribute('data-huve-pending');
          }
        });
      }
      refresh() {
        const panel = this.panel();
        this.hidden = !this.isEligible(panel);
        const hasStand = Boolean(this.selectedStand());
        if (!hasStand) this.selection = 'none';
        this.setAttribute('aria-busy', String(this.pending));
        this.querySelectorAll('input[type="radio"]').forEach(input => {
          const stand = this.stand(input.value, panel);
          input.disabled = this.pending || (input.value !== 'none' && (!panel?.available || !stand?.available));
          input.checked = input.value === this.selection;
        });
        this.querySelectorAll('[data-stand]').forEach(card => {
          const stand = this.stand(card.dataset.stand, panel);
          card.querySelector('[data-price]').textContent = stand ? `+ ${this.formatter.format(stand.price / 100)}` : '';
          card.querySelector('[data-availability]').textContent = stand
            ? this.config.strings[stand.available ? 'available' : 'soldOut'].replace('__colour__', stand.colour)
            : this.config.strings.unavailable;
          const image = card.querySelector('img');
          if (image && stand?.image) {
            image.removeAttribute('srcset');
            image.src = stand.image;
          }
          if (stand?.url) card.querySelector('a').href = stand.url;
        });
        const total = ((panel?.price || 0) + (this.selectedStand()?.price || 0)) * this.quantity();
        this.querySelector('[data-total]').textContent = this.formatter.format(total / 100);
        this.querySelector('[data-summary]').textContent = hasStand ? this.config.strings.withStand : this.config.strings.panelOnly;
        this.productForm.dataset.huveStandSelected = String(hasStand);
        if (this.closest('safe-sticky')) this.closest('safe-sticky').dataset.huveStandSelected = String(hasStand);
        this.restoreButtons();
        this.buttons().forEach(button => {
          const content = button.contentElement || button;
          if (!this.buttonLabels.has(button)) this.buttonLabels.set(button, content.textContent.trim());
          if (hasStand && !button.disabled) content.textContent = this.config.strings.addBoth;
          if (this.pending && !button.disabled) {
            button.setAttribute('data-huve-pending', '');
            button.disabled = true;
          }
        });
      }
      setError(message) {
        const error = this.querySelector('[data-error]');
        error.textContent = message;
        error.hidden = !message;
      }
      addStand(formData) {
        const stand = this.selectedStand();
        if (!stand || formData.has('items[0][id]')) return;
        const id = formData.get('id');
        if (String(id) !== String(this.panel()?.id)) return;
        const quantity = formData.get('quantity') || '1';
        const fields = Array.from(formData.entries()).filter(([name]) => name === 'id' || name === 'quantity' || name === 'selling_plan' || /^properties\[.*\]$/.test(name));
        fields.forEach(([name, value]) => {
          const itemName = name.startsWith('properties[') ? `items[0][properties]${name.slice(10)}` : `items[0][${name}]`;
          formData.append(itemName, value);
          formData.delete(name);
        });
        formData.set('items[0][quantity]', quantity);
        formData.set('items[1][id]', String(stand.id));
        formData.set('items[1][quantity]', quantity);
      }
    }
    customElements.define('huve-stand-selector', HuveStandSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
